import HeroSection from "./components/HeroSection";
import CommentInputBox from "../../../components/CommentBox/CommentInputBox";
import UserCommentSection from "./components/UserComments";
import {useCommunity} from "../../../redux/Reducers/CommunityComments";
import useCommunityStats from "../../../hooks/useCommunityStats";


function PersonPracticeData({total, totalQuestion, todayPractice}) {

    return (
        <div className={"flex flex-col w-full gap-4 justify-center items-center"}>
            <p className={"font-bold mt-2 text-center text-lg "}>
                Personal Practiced Data
            </p>

            <div className={"w-full grid gap-4   grid-cols-2"}>
                <div className={"bg-[#F0F7FF] m-auto w-full pb-3 flex flex-col justify-center items-center rounded-sm"}>
                    <p className={"text-4xl font-bold text-tertiary-900"}>
                        {total || 0}
                    </p>
                    <p className={"text-xs"}>
                        Total Practiced
                    </p>

                </div>
                <div className={"bg-[#F0F7FF] m-auto w-full pb-3 flex flex-col justify-center items-center rounded-sm"}>
                    <p className={"text-4xl font-bold text-tertiary-900"}>
                        {totalQuestion || 0}
                    </p>
                    <p className={"text-xs"}>
                        Total Questions
                    </p>
                </div>
                <div className={"bg-[#F0F7FF] m-auto w-full pb-3 flex flex-col justify-center items-center rounded-sm"}>
                    <p className={"text-4xl font-bold text-tertiary-900"}>
                        {todayPractice || 0}
                    </p>
                    <p className={"text-xs"}>
                        Today Practice
                    </p>
                </div>
            </div>
        </div>
    )
}


export default function CommunityIndex({className, ...props}) {
    const {state, isLoading, actions} = useCommunity();
    const [data] = useCommunityStats();

    function onAddComment(comment) {
        actions.addNewComment(comment);

    }

    return (
        <div className={` w-full ${className}`}>
            <HeroSection/>
            <div className={"main px-8 2xl:px-[7rem] mt-10 flex py-2"}>
                <div className={"flex-[3] flex flex-col gap-2"}>
                    <CommentInputBox onAddComment={onAddComment}/>
                    <UserCommentSection/>
                </div>
                <div>
                    <div className={" hidden lg:flex justify-center pl-8"}>

                        <div className={"flex gap-8 flex-col border-[1px]  pb-14 p-4 w-full  rounded-lg"}>


                            {/*Total Practiced  */}
                            <div className={"p-4  rounded-lg gap-2 shadow-md "}>
                                <p className={"font-bold mt-2 text-center text-lg "}>
                                    Total practiced
                                </p>
                                <p className={"text-4xl text-tertiary-900 font-bold whitespace-nowrap text-center "}>
                                    {data?.totalPracticedByAll || 0}
                                </p>

                            </div>

                            <PersonPracticeData
                                todayPractice={data?.totalToday}
                                total={data?.totalPracticed}
                                totalQuestion={data?.totalQuestions}
                            />

                            {/*Total Practiced Ranking  */}
                            <div className={"line"}/>
                            <div className={"flex flex-col w-full justify-center items-center"}>
                                <div className={"text-start flex flex-col gap-2  "}>
                                    <p className={"text-2xl font-bold mb-2 whitespace-nowrap"}>
                                        Today's Practice Ranking
                                    </p>

                                    {
                                        data?.todayPracticedRanking?.map((item, index) => (
                                            <p className={"text-lg font-normal whitespace-nowrap"}>
                                            <span
                                                className={"font-bold"}>{index + 1})</span>{" "}{item?.user || "user"} has
                                                practiced <span
                                                className={"text-secondary-900"}>{item?.practiced_count} </span> questions
                                            </p>
                                        ))
                                    }


                                </div>


                            </div>


                            {/*Total Practiced Ranking  */}
                            <div className={"line"}/>
                            <div className={"flex flex-col w-full justify-center items-center"}>
                                <div className={"text-start flex flex-col gap-2  "}>
                                    <p className={"text-2xl text-tertiary-900 font-bold mb-2 whitespace-nowrap"}>
                                        Practice Ranking
                                    </p>

                                    {
                                        data?.overallPracticedRanking?.map((item, index) => (
                                            <p className={"text-lg font-normal whitespace-nowrap"}>
                                            <span
                                                className={"font-bold"}>{index + 1})</span>{" "}{item?.user || "user"} has
                                                practiced <span
                                                className={"text-secondary-900"}>{item?.practiced_count} </span> questions
                                            </p>
                                        ))
                                    }

                                </div>


                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
}